import React from "react";
import "./announcement.css";
const Announcement = () => {
  return (
    <div className="announcement">
      <p>
        New! Concealer blender is here - <a href="#concealer">Shop now</a>
      </p>
    </div>
  );
};

export default Announcement;
